// extracted by mini-css-extract-plugin
export var closeButton = "_8m-0";